import React from "react";
import Header from "./Header";
import '../../styles/TerminiCondizioniPage.scss';
import Arrow from "./Arrow";
import Footer from "./Footer";

const PrivacyPolicyPage = () => {
    return (
        <div className="termini-privacy-container">
            <Header>
                <div className='header-child'>
                    <h1 data-aos="fade-right">Informativa sulla Privacy</h1>
                    <Arrow direction="down" size="small" animated={true}/>
                </div>
            </Header>
        
            
            <div className="termini-condizioni">
                <h2>1. Introduzione</h2>
                <p>
                    Questa Informativa sulla Privacy descrive come il sito web www.cosyhole.it (di seguito "il Sito") gestisce i dati personali degli utenti. La protezione della tua privacy è importante per noi, e ci impegniamo a trattare i tuoi dati personali in conformità con le leggi applicabili.
                </p>

                <h2>2. Dati Personali Raccolti</h2>
                <p>
                    Non raccogliamo dati personali degli utenti attraverso questo sito. Il sito è progettato unicamente per visualizzare il menù del nostro pub e non richiede la raccolta di informazioni personali da parte degli utenti.
                </p>

                <h2>3. Finalità del Trattamento</h2>
                <p>
                    Poiché non raccogliamo dati personali, non trattiamo alcun dato a fini specifici.
                </p>

                <h2>4. Condivisione dei Dati con Terze Parti</h2>
                <p>
                    Poiché non raccogliamo dati personali, non condividiamo alcun dato con terze parti.
                </p>

                <h2>5. Sicurezza dei Dati</h2>
                <p>
                    Anche se non raccogliamo dati personali, ci impegniamo a mantenere il sito sicuro da accessi non autorizzati e a garantire la sicurezza delle informazioni visualizzate.
                </p>

                <h2>6. Diritti dell'Utente</h2>
                <p>
                    Gli utenti del nostro sito hanno il diritto di:
                    <br/><br/>
                    Accedere alle informazioni pubblicate sul sito.<br/>
                    Navigare il sito in modo anonimo, senza che vengano raccolti dati personali.
                </p>
                
                <h2>7. Modifiche alla Privacy Policy</h2>
                <p>
                    Questa informativa potrebbe essere aggiornata periodicamente per riflettere eventuali modifiche al nostro sito o ai requisiti legali. Ti invitiamo a consultare questa pagina regolarmente per eventuali aggiornamenti.
                </p>

                <h2>8. Contatti</h2>
                <p>Se hai domande o preoccupazioni riguardanti questa Informativa sulla Privacy, puoi contattarci ai seguenti recapiti:
                    <br/><br/>
                    Tel: +39 0734 241815
                    Cell: +39 375 887 2791
                    <br/>
                    Indirizzo: Via del Forno, 3, 63827 Pedaso (FM), Italia
                </p>
            </div>
            <Footer />
        </div>
    )
};

export default PrivacyPolicyPage;